import { render } from "./menu-carousel.vue?vue&type=template&id=0895fc15"
import script from "./menu-carousel.vue?vue&type=script&lang=js"
export * from "./menu-carousel.vue?vue&type=script&lang=js"

import "./menu-carousel.vue?vue&type=style&index=0&id=0895fc15&lang=scss"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__